// Uses window.crypto to generate a random ID
// it is used only in web applications
export const getRandomID = () => window.crypto.getRandomValues(new Uint32Array(1))[0].toString(36).slice(2, 9);
